import { createClient } from '@/shared/api';
import type { ShipmentParcelsQuery } from '@/shared/api';
import SHIPMENT_PARCELS_QUERY from '../queries/shipmentParcels';

/**
 * Loads the parcel options offered when creating an RMA shipping label. Runs SHIPMENT_PARCELS_QUERY and returns the shipmentParcels field without inspecting errors.
 *
 * @returns The available shipment parcels, or undefined.
 */
const fetchShipmentParcels = async () => {
  const client = createClient();
  const result = await client.query<ShipmentParcelsQuery>({
    query: SHIPMENT_PARCELS_QUERY,
  });
  return result?.data?.shipmentParcels;
};

export default fetchShipmentParcels;
